export default {
    'newsletter.title': 'Seien Sie immer die Ersten',
    'newsletter.btn': 'Abonnieren',
    'newsletter.placeholder': 'Ihre E-Mail-Adresse',
    'newsletter.subtitle': 'Bleiben Sie informiert und erfahren Sie Neuigkeiten als Erste!',
    'instagram.title': 'Folgen Sie uns',
    'contact.title': 'Brauchen Sie Hilfe?',
    'contact.hours': 'Mo – Fr: 9:00 – 19:00',
    'login.title': 'Anmeldung',
    'cart.orderRecap': 'Bestellübersicht',
    'cart.empty': 'Ihr Warenkorb ist leer',
    'cart.back': 'Zurück zum Shop'
};